import type {
	FieldValues,
	Path,
	PathValue,
	UseFormSetValue,
} from 'react-hook-form';

export type BuildFieldPath<
	TFieldValues extends FieldValues,
	TBaseName extends string | undefined,
	TFieldKey extends string,
> = TBaseName extends string
	? `${TBaseName}.${TFieldKey}` extends Path<TFieldValues>
		? `${TBaseName}.${TFieldKey}`
		: never
	: TFieldKey extends Path<TFieldValues>
		? TFieldKey
		: never;

export function buildFieldPath<TBaseName extends string | undefined>(
	baseName: TBaseName | undefined,
	fieldKey: string,
): string {
	return baseName ? `${baseName}.${fieldKey}` : fieldKey;
}

export function resetField<TFieldValues extends FieldValues>(
	setValue: UseFormSetValue<TFieldValues>,
	path: Path<TFieldValues>,
): void {
	setValue(path, undefined as PathValue<TFieldValues, Path<TFieldValues>>, {
		shouldDirty:    true,
		shouldValidate: true,
	});
}

export function isNonEmptyString(value: unknown): value is string {
	return typeof value === 'string' && value.length > 0;
}
